import { Card } from 'react-bootstrap';
import './style.css'
import { useNavigate } from 'react-router-dom';

const AsoValidarIndentidadeEmpresa = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/aso/registro/validar-identidade');
    }

    return(
        <>
            <Card className='aso-card-validar-id-empresa'>
                <div className='aso-card-header-id'>
                    <div className='aso-card-header-id-reference'>
                        <div className='aso-card-header-id-inner-reference'>
                            <img rel="preload" src="https://mobile.mercadolibre.com/remote_resources/image/remedy_ic_landing_mp?density=xxxhdpi" alt="landing" />
                        </div>
                    </div>
                </div>
                <div className='aso-card-header-id-title-container'>
                    <p className='aso-card-header-id-title'>Agora, vamos validar sua identidade</p>
                </div>
                <div className='aso-card-description-container'>
                    <div className='aso-card-description-container-info'>
                        <p>Precisamos ter certeza de que você é a pessoa legalmente autorizada a agir em nome da sociedade.</p>
                        <p>Pegue sua CNH ou RG e procure um lugar tranquilo e com boa iluminação. Leva só alguns minutos!</p>
                    </div>
                    <div className='aso-card-description-container-button'>
                        <button onClick={() => navigate('/aso/registro/validar-identidade-empresa')}>Voltar</button>
                        <button onClick={handleClick}>Começar</button>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default AsoValidarIndentidadeEmpresa;